Vendd.Scripts.load(function () {

    var $wrapper = $('.store-locator-page');

    if ($wrapper.length < 1) return;



});